import { Outlet, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { GuestGate } from '@/components/security/GuestGate';

export const ProtectedRoute: React.FC = () => {
    const { user, loading } = useAuth();
    const [searchParams] = useSearchParams();
    const inviteCode = searchParams.get('code');

    if (loading) {
        return <div className="p-8 text-center">Loading...</div>;
    }

    // If there's an invite code, force GuestGate to handle it (switch user)
    // regardless of current auth state.
    if (!user || inviteCode) {
        return <GuestGate />;
    }

    return <Outlet />;
};
